<template>
  <a :href="href" class="help" :class="classes" :aria-label="title" :title="title">
    <i class="material-symbols-outlined" aria-hidden="true">{{ icon }}</i>
  </a>
</template>

<script>
export default {
  name: 'TutorialLinkButton',
  props: {
    href: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>
